'use client';

import Image from "next/image"

import mobileImageRESTITUZIONE from '@/assets/images/mobile/consulente-mostra-informazioni-su-smartphone.webp'
import desktopImageRESTITUZIONE from '@/assets/images/desktop/consulente-mostra-informazioni-su-smartphone.webp'


interface Props {
    actionButton?(): void
}

const LightBlueTitle: React.FC<Props> = ({ actionButton }: Props) => {

    // restituzione flessibile
    return <div className='mx-5 lg:mx-40 mb-20 lg:mb-40 '>
        <div className='text-center mb-10 lg:mb-20'>
            <h1 className='lg:mb-5'>Come ottenere il co-finanziamento?</h1>
            <div>Ogni mese versi <strong>almeno 10€</strong> nel tuo fondo, ma puoi aumentare il tuo co-finanziamento con questi bonus:</div>
        </div>
        <div className='grid grid-cols-2 gap-8'>
            <div className='col-span-2 lg:col-span-1'>
                <Image src={mobileImageRESTITUZIONE} alt="Professionista sorridente che mostra informazioni sullo smartphone a un’altra persona durante una consulenza." className='rounded-cornerMob lg:hidden' />
                <Image src={desktopImageRESTITUZIONE} alt="Professionista sorridente che mostra informazioni sullo smartphone a un’altra persona durante una consulenza." className='rounded-cornerDesk hidden lg:block' />
            </div>
            <div className='col-span-2 lg:col-span-1 lg:flex lg:flex-col lg:justify-center'>

                <div className='mb-8'>
                    <div className='mb-3 lg:w-10/12 2xl:w-1/2'>
                        <h2 className='bg-grayLight py-2 px-5 rounded-cornerMob'>Performance accademica</h2>
                    </div>
                    <div>
                        Se ottieni almeno <strong>20 CFU a semestre</strong>, oppure 10 CFU se dimostri di essere uno studente che lavora o svolge sport a livello agonistico, sblocchi tutti gli altri bonus.
                    </div>
                </div>
                <div className='mb-8'>
                    <div className='mb-3 lg:w-10/12 2xl:w-1/2'>
                        <h2 className='bg-grayLight py-2 px-5 rounded-cornerMob'>Fragilità economica o fisica</h2>
                    </div>
                    <div>
                        Se hai un ISEE fino a 27.948,60€ o una certificazione medica, puoi ricevere un bonus extra.
                    </div>
                </div>
                <div className='mb-8'>
                    <div className='mb-3 lg:w-10/12 2xl:w-1/2'>
                        <h2 className='bg-grayLight py-2 px-5 rounded-cornerMob'>Volontariato</h2>
                    </div>
                    <div>
                        Se partecipi ad attività di volontariato certificate, ottieni un contributo aggiuntivo.
                    </div>
                </div>
                <div className=''>
                    <div className='mb-3 lg:w-10/12 2xl:w-1/2'>
                        <h2 className='bg-grayLight py-2 px-5 rounded-cornerMob'>Educazione finanziaria</h2>
                    </div>
                    <div>
                        Completando il nostro test sull’app, ricevi un ulteriore bonus.
                    </div>
                </div>
            </div>
        </div>

    </div>
}

export default LightBlueTitle;